<template>
    <div class="review-and-pay">
      <div class="campaign-review">
        <PaymentSuccess v-if="paymentStatusSuccess" @closePopup="handleClosePopupEvent" />
        <PaymentCancel v-if="paymentStatusCancel" @closePopup="handleClosePopupEvent"/>
        <PaymentFaild v-if="paymentStatusfalid" @closePopup="handleClosePopupEvent" />
      </div> 
  
      <div class="payment-iframe">
        <div id="geidea-checkout"></div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import PaymentSuccess from "./PaymentSuccess.vue";
  import PaymentCancel from "./PaymentCancel.vue";
  import PaymentFaild from "./PaymentFaild.vue";
  import store from "../../store";
  import { mapState, mapGetters, mapMutations } from "vuex";
  import { calculateDaysDifference } from "../../utils";
  export default {
    name: "ReviewAndPay",
    components: {
      PaymentSuccess,
      PaymentCancel,
      PaymentFaild,
    },
    props: {
      campaignId: {
        type: String,
        required: true
      },
      amount: {
        type: Number,
        required: false,
      }
    },
    data() {
      return {
        paymentStatusSuccess: false,
        paymentStatusCancel: false,
        paymentStatusfalid: false,
        stepOneData: {},
        scriptId: 'geidea-checkout-script',
        sessionId: '',
        // stepTwoData: {},
        // stepThreeData: {},
        // stepFourData: {},
        // Your component data here
      };
    },
    async mounted() {
      this.stepOneData = this.step_one;
      console.log('campaign id: ',this.campaignId); 
      // Load GeideaCheckout script
      await this.createPaymentSession();
  
      const script = document.createElement("script");
      script.src = "https://www.ksamerchant.geidea.net/hpp/geideaCheckout.min.js";
      script.id = this.scriptId;
      script.onload = this.initializeGeideaCheckout;
      document.head.appendChild(script);
    },
    beforeUnmount(){
      const existingScript = document.getElementById(this.scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    },
    computed: {
      ...mapGetters(["step_one"]),
      ...mapGetters(["step_two"]),
      ...mapGetters(["step_three"]),
      ...mapGetters(["getAllUserData"]),
      ...mapGetters(["ReviewPaymentState"]),
    },
    watch: {
      ReviewPaymentState(newValue, oldValue) {
      console.log(`State variable changed from ${oldValue} to ${newValue}`);
    }
  },
    methods: {
      getFormattedDate() {
        const now = new Date();

        const month = now.getMonth() + 1; // Months are zero-based
        const day = now.getDate();
        const year = now.getFullYear();

        const hours = now.getHours();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();

        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert to 12-hour format

        const formattedDate = `${month}/${day}/${year} ${formattedHours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${ampm}`;
        
        return formattedDate;
      },
      initializeGeideaCheckout() {
        console.log("sessionId from initializeGeideaCheckout", this.sessionId);
        // onSuccess function definition
        const onSuccess = (data) => {
          console.log("Payment successful:", data);
          this.$emit('handleSuccess')
        };
  
        // onError function definition
        const onError = (data) => {
          this.$emit('handleError')
        };
  
        // onCancel function definition
        const onCancel = (data) => {
          this.$emit('handleCancel')
        };
  
        const payment = new GeideaCheckout(onSuccess, onError, onCancel);
  
        try {
          const response = payment.startPayment(this.sessionId);
  
          console.log(response);
        } catch (error) {
          console.error("Payment initialization error:", error);
          alert("Payment initialization error: " + error.message);
        }
      },
      async createPaymentSession() {
        const days = calculateDaysDifference(this.step_three.duration.start, this.step_three.duration.end)
        const price = parseFloat(this.step_three.budget) * days
        await store.dispatch("getUserData");
        const res = await axios.post(
          "https://api-payment.dkilo.net/payment/create-session",
          {
            amount: this.amount || price,
            currency: this.$store.state.auth.country_code === "EG" ? "EGP" : "SAR",
            timestamp: this.getFormattedDate(),
            merchantReferenceId: "dKilo",
            paymentOperation: "Pay",
            metadata: {
              custom: this.campaignId,
            },
            appearance: {
              uiMode: "modal",
              styles: {
                hppProfile: "compressed",
              },
            },
            language: "en",
            callbackUrl: "https://api-payment.dkilo.net/payment/callback",
            customer: {
              email: this.getAllUserData.publisher.email,
              phoneNumber: this.getAllUserData.publisher.mobile,
            },
            appearance: {
            styles: {
              hppProfile: "compressed",
            },
              uiMode: "modal",
              showEmail: true,
              showAddress: true,
              showPhone: true,
              receiptPage: true,
            },
            initiatedBy: "Internet",
          }
        )
        this.sessionId = res.data.session.id;
      },
    },
  };
  </script>
  
  <style scoped>
.review-and-pay {
  display: flex;
  justify-content: space-between;
}

.campaign-review {
  width: 48%;
  /* Additional styles for campaign review */
}

.payment-iframe {
  width: 48%;
  /* Additional styles for payment iframe */
}

.payment-iframe #geidea-checkout {
  width: 100%;
  height: 500px; /* Adjust height as needed */
  border: none; /* Remove border if any */
}
  </style>
  